musicManager = {};
musicManager.idle = true;
musicManager.inFreespins = false;
musicManager.inGamble = false;
musicManager.inMaxPlay = false;
musicManager.wasInFreeSpins = false;
musicManager.inBaseGameModifier = false;
musicManager.musicLevel = 1;

musicManager.freeSpinsIntroLoop = undefined;
musicManager.freeSpinsIntroLoopMaxVolume = 0.36;

musicManager.ALLOFFLEVEL = [false, false, false];
musicManager.IDLELEVEL = [true, false, false];
musicManager.SPINLEVEL = [false, true, false];
musicManager.SINGLEWINLEVEL = [false, false, true];

musicManager.MAXPLAY_ALLOFF = [false, false, false];
musicManager.MAXPLAY_BASE = [true, false, false];
musicManager.MAXPLAY_LEVEL1 = [false, true, false];
musicManager.MAXPLAY_LEVEL2 = [false, false, true];

musicManager.FREESPINS_ALLOFF = [false, false, false, false];
musicManager.FREESPINS_BASE = [true, false, false, false];
musicManager.FREESPINS_LEVEL1 = [false, true, false, false];
musicManager.FREESPINS_LEVEL2 = [false, false, true, false];

musicManager.soundsToFadeOut = [];
musicManager.soundsToFadeIn = [];

musicManager.steppingDown = false;

musicManager.fadeInTimer = undefined;
musicManager.fadeOutTimer = undefined;

musicManager.soundsToFadeOutFS = [];
musicManager.soundsToFadeInFS = [];

musicManager.soundsToFadeOutMaxPlay = [];
musicManager.soundsToFadeInMaxPlay = [];

musicManager.fadeInTimerFS = undefined;
musicManager.fadeOutTimerFS = undefined;

musicManager.initialise = function () {
  musicManager.volume = 0;
  musicManager.playing = false;
  musicManager.soundTags = soundManager.soundsConfig.tags;

  musicManager.fadeBaseTimeIn = 1;
  musicManager.fadeBaseTimeOut = 0.7;

  musicManager.fadeBigWinTimeIn = 0.2;
  musicManager.fadeBigWinTimeOut = 0.2;

  musicManager.maxMusicVolume = 0.48;

  musicManager.stepDownTimer = undefined;
  musicManager.stepDownDuration = 10000;

  musicManager.baseID = [];
  musicManager.freeSpinsID = [];
  musicManager.maxPlayID = [];
  musicManager.gambleID = [];

  musicManager.freeSpinsLevel = musicManager.FREESPINS_ALLOFF;

  musicManager.baseMusic = ["gameTheme0", "gameTheme1", "gameTheme2"];
  musicManager.maxPlayMusic = ["maxPlayLoop0", "maxPlayLoop1", "maxPlayLoop2"];
  musicManager.freeSpinsMusic = [
    "freeSpinsLoop1",
    "freeSpinsLoop2",
    "freeSpinsLoop3",
  ];
  musicManager.gambleMusic = ["gameTheme3", "maxPlayLoop3"];

  musicManager.basePlaying = [false, false, false, false];
  musicManager.fsPlaying = [false, false, false];
  musicManager.maxPlayPlaying = [false, false, false, false];

  musicManager.previouslyPlayingBeforeFade = [];
};

musicManager.onGameLoaded = function () {
  // setup base music tracks - all volumes 0
  for (var i = 0; i < musicManager.baseMusic.length; i++) {
    musicManager.baseID.push(soundManager.play(musicManager.baseMusic[i]));
    soundManager.setVolume(0, musicManager.baseID[i]);
  }

  // setup free spins music tracks - all volumes 0
  for (var j = 0; j < musicManager.freeSpinsMusic.length; j++) {
    musicManager.freeSpinsID.push(
      soundManager.play(musicManager.freeSpinsMusic[j])
    );
    soundManager.setVolume(0, musicManager.freeSpinsID[j]);
  }

  // setup maxplay music tracks - all volumes 0
  for (var j = 0; j < musicManager.maxPlayMusic.length; j++) {
    musicManager.maxPlayID.push(
      soundManager.play(musicManager.maxPlayMusic[j])
    );
    soundManager.setVolume(0, musicManager.maxPlayID[j]);
  }

  // setup gamble music tracks - all volumes 0
  for (var j = 0; j < musicManager.gambleMusic.length; j++) {
    musicManager.gambleID.push(soundManager.play(musicManager.gambleMusic[j]));
    soundManager.setVolume(0, musicManager.gambleID[j]);
  }

  musicManager.freeSpinsIntroLoop = soundManager.play("freeSpinsIntroLoop");
  soundManager.setVolume(0, musicManager.freeSpinsIntroLoop);

  musicManager.fadeLevels(
    musicManager.IDLELEVEL,
    musicManager.fadeBaseTimeIn,
    musicManager.fadeBaseTimeOut
  );
};

musicManager.onGameStart = function () {
  musicManager.steppingDown = true;

  if (musicManager.inMaxPlay) {
    if (musicManager.maxPlayPlaying != musicManager.MAXPLAY_LEVEL2) {
      musicManager.steppingDown = false;
      timerManager.stop(musicManager.stepDownTimer);
    }
  } else {
    if (musicManager.basePlaying != musicManager.SINGLEWINLEVEL) {
      musicManager.steppingDown = false;
      timerManager.stop(musicManager.stepDownTimer);
    }
  }

  musicManager.idle = false;

  if (!musicManager.playing && !musicManager.inFreespins) {
    musicManager.playing = true;

    if (musicManager.inMaxPlay) {
      if (musicManager.maxPlayPlaying === musicManager.MAXPLAY_BASE) {
        musicManager.fadeMaxPlayLevels(
          musicManager.MAXPLAY_LEVEL1,
          musicManager.fadeBaseTimeIn,
          musicManager.fadeBaseTimeOut
        );
      }
    } else {
      if (musicManager.basePlaying === musicManager.IDLELEVEL) {
        musicManager.fadeLevels(
          musicManager.SPINLEVEL,
          musicManager.fadeBaseTimeIn,
          musicManager.fadeBaseTimeOut
        );
      }
    }
  }
};

musicManager.onGameEnd = function () {
  musicManager.idle = true;
  musicManager.playing = false;

  if (!musicManager.steppingDown) {
    timerManager.stop(musicManager.stepDownTimer);

    musicManager.stepDownTimer = timerManager.addTimeout(
      musicManager.stepDownDuration,
      () => {
        musicManager.stepDown();
      }
    );
  }
};

musicManager.stepUp = function () {
  timerManager.stop(musicManager.stepDownTimer);

  if (musicManager.inMaxPlay) {
    if (musicManager.maxPlayPlaying == musicManager.MAXPLAY_LEVEL1) {
      musicManager.fadeMaxPlayLevels(
        musicManager.MAXPLAY_LEVEL2,
        musicManager.fadeBaseTimeIn,
        musicManager.fadeBaseTimeOut
      );
    }
  } else {
    if (musicManager.basePlaying == musicManager.SPINLEVEL) {
      musicManager.fadeLevels(
        musicManager.SINGLEWINLEVEL,
        musicManager.fadeBaseTimeIn,
        musicManager.fadeBaseTimeOut
      );
    }
  }
};

musicManager.stepDown = function () {
  if (musicManager.inMaxPlay) {
    switch (musicManager.maxPlayPlaying) {
      case musicManager.MAXPLAY_LEVEL2:
        musicManager.stepDownTimer = timerManager.addTimeout(
          musicManager.stepDownDuration,
          () => {
            musicManager.stepDown();
          }
        );
        musicManager.fadeMaxPlayLevels(
          musicManager.MAXPLAY_LEVEL1,
          musicManager.fadeBaseTimeIn,
          musicManager.fadeBaseTimeOut
        );
        break;

      case musicManager.MAXPLAY_LEVEL1:
        timerManager.stop(musicManager.stepDownTimer);
        musicManager.fadeMaxPlayLevels(
          musicManager.MAXPLAY_BASE,
          musicManager.fadeBaseTimeIn,
          musicManager.fadeBaseTimeOut
        );
        break;
    }
  } else {
    switch (musicManager.basePlaying) {
      case musicManager.SINGLEWINLEVEL:
        musicManager.stepDownTimer = timerManager.addTimeout(
          musicManager.stepDownDuration,
          () => {
            musicManager.stepDown();
          }
        );
        musicManager.fadeLevels(
          musicManager.SPINLEVEL,
          musicManager.fadeBaseTimeIn,
          musicManager.fadeBaseTimeOut
        );
        break;

      case musicManager.SPINLEVEL:
        timerManager.stop(musicManager.stepDownTimer);
        musicManager.fadeLevels(
          musicManager.IDLELEVEL,
          musicManager.fadeBaseTimeIn,
          musicManager.fadeBaseTimeOut
        );
        break;
    }
  }
};

musicManager.playBigWin = function () {
  musicManager.bigWinID = soundManager.play("bigWinLoop");

  timerManager.stop(musicManager.stepDownTimer);

  soundManager.fade(
    0,
    musicManager.fadeBigWinTimeOut,
    musicManager.gambleID[0]
  );
  soundManager.fade(
    0,
    musicManager.fadeBigWinTimeOut,
    musicManager.gambleID[1]
  );

  if (musicManager.inFreespins) {
    musicManager.fadeFSLevels(
      musicManager.FREESPINS_ALLOFF,
      musicManager.fadeBigWinTimeIn,
      musicManager.fadeBigWinTimeOut
    );
  } else if (musicManager.inMaxPlay) {
    musicManager.fadeMaxPlayLevels(
      musicManager.MAXPLAY_ALLOFF,
      musicManager.fadeBigWinTimeIn,
      musicManager.fadeBigWinTimeOut
    );
  } else {
    musicManager.fadeLevels(
      musicManager.ALLOFFLEVEL,
      musicManager.fadeBigWinTimeIn,
      musicManager.fadeBigWinTimeOut
    );
  }
};

musicManager.fadeBigWin = function () {
  soundManager.fade(0, 2, musicManager.bigWinID, () => {
    soundManager.stop(musicManager.bigWinID);
  });
};

/////////////////////////////////
// Pass in 5 item array - with levels that need to be on and off )
// e.g. F,F,T,T,F will play levels 2 and 3 ( indexed from 0 )
////////////////////////
musicManager.fadeLevels = function (levels, fadeInTime, fadeOutTime) {
  // at end as we may not have a channel currently playing - musicManager.basePlaying = levels;
  musicManager.soundsToFadeOut = [];
  musicManager.soundsToFadeIn = [];

  for (var i = 0; i < levels.length; i++) {
    if (levels[i] === true && musicManager.basePlaying[i] === false) {
      // we want to play but it's currently silent - fade in level
      musicManager.soundsToFadeIn.push(musicManager.baseID[i]);
    } else if (levels[i] === false && musicManager.basePlaying[i] === true) {
      // currently playing but make silent
      musicManager.soundsToFadeOut.push(musicManager.baseID[i]);
    }
  }

  for (var i = 0; i < musicManager.soundsToFadeIn.length; i++) {
    soundManager.fade(
      musicManager.maxMusicVolume,
      fadeInTime,
      musicManager.soundsToFadeIn[i],
      undefined
    );
  }

  for (var i = 0; i < musicManager.soundsToFadeOut.length; i++) {
    soundManager.fade(
      0,
      fadeOutTime,
      musicManager.soundsToFadeOut[i],
      undefined
    );
  }

  musicManager.basePlaying = levels;
};

musicManager.fadeFSLevels = function (levels, fadeInTime, fadeOutTime) {
  musicManager.soundsToFadeOutFS = [];
  musicManager.soundsToFadeInFS = [];

  for (var i = 0; i < levels.length; i++) {
    if (levels[i] === true && musicManager.fsPlaying[i] === false) {
      // we want to play but it's currently silent - fade in level
      musicManager.soundsToFadeInFS.push(musicManager.freeSpinsID[i]);
    } else if (levels[i] === false && musicManager.fsPlaying[i] === true) {
      // currently playing but make silent
      musicManager.soundsToFadeOutFS.push(musicManager.freeSpinsID[i]);
    }
  }

  for (var i = 0; i < musicManager.soundsToFadeInFS.length; i++) {
    soundManager.fade(
      musicManager.maxMusicVolume,
      fadeInTime,
      musicManager.soundsToFadeInFS[i],
      undefined
    );
  }

  for (var i = 0; i < musicManager.soundsToFadeOutFS.length; i++) {
    soundManager.fade(0, fadeOutTime, musicManager.soundsToFadeOutFS[i]);
  }

  musicManager.fsPlaying = levels;
};

musicManager.fadeMaxPlayLevels = function (levels, fadeInTime, fadeOutTime) {
  musicManager.soundsToFadeOutMaxPlay = [];
  musicManager.soundsToFadeInMaxPlay = [];

  for (var i = 0; i < levels.length; i++) {
    if (levels[i] === true && musicManager.maxPlayPlaying[i] === false) {
      // we want to play but it's currently silent - fade in level
      musicManager.soundsToFadeInMaxPlay.push(musicManager.maxPlayID[i]);
    } else if (levels[i] === false && musicManager.maxPlayPlaying[i] === true) {
      // currently playing but make silent
      musicManager.soundsToFadeOutMaxPlay.push(musicManager.maxPlayID[i]);
    }
  }

  for (var i = 0; i < musicManager.soundsToFadeInMaxPlay.length; i++) {
    soundManager.fade(
      musicManager.maxMusicVolume,
      fadeInTime,
      musicManager.soundsToFadeInMaxPlay[i],
      undefined
    );
  }

  for (var i = 0; i < musicManager.soundsToFadeOutMaxPlay.length; i++) {
    soundManager.fade(0, fadeOutTime, musicManager.soundsToFadeOutMaxPlay[i]);
  }

  musicManager.maxPlayPlaying = levels;
};

musicManager.gambleEnter = function () {
  if (musicManager.inFreespins) return;
  if (musicManager.inGamble) return;

  musicManager.inGamble = true;

  if (musicManager.inMaxPlay) {
    soundManager.fade(
      musicManager.freeSpinsIntroLoopMaxVolume,
      1.5,
      musicManager.gambleID[1]
    );
    musicManager.fadeMaxPlayLevels(musicManager.MAXPLAY_ALLOFF, 1, 1);
  } else {
    soundManager.fade(
      musicManager.freeSpinsIntroLoopMaxVolume,
      1.5,
      musicManager.gambleID[0]
    );
    musicManager.fadeLevels(musicManager.ALLOFFLEVEL, 1, 1);
  }
};

musicManager.gambleExit = function () {
  musicManager.inGamble = false;

  if (musicManager.inMaxPlay) {
    soundManager.fade(0, 1.5, musicManager.gambleID[1]);
    musicManager.fadeMaxPlayLevels(
      musicManager.MAXPLAY_BASE,
      musicManager.fadeBaseTimeIn,
      musicManager.fadeBaseTimeOut
    );
  } else {
    soundManager.fade(0, 1.5, musicManager.gambleID[0]);
    musicManager.fadeLevels(
      musicManager.IDLELEVEL,
      musicManager.fadeBaseTimeIn,
      musicManager.fadeBaseTimeOut
    );
  }
};

musicManager.gambleSpin = function () {
  soundManager.play("gambleStart");
  soundManager.play("gambleSpin");

  if (musicManager.inMaxPlay) {
    soundManager.fade(0.1, 0.5, musicManager.gambleID[1]);
  } else {
    soundManager.fade(0.1, 0.5, musicManager.gambleID[0]);
  }
};

musicManager.gambleLand = function () {
  if (musicManager.inMaxPlay) {
    soundManager.fade(
      musicManager.freeSpinsIntroLoopMaxVolume,
      2,
      musicManager.gambleID[1]
    );
  } else {
    soundManager.fade(
      musicManager.freeSpinsIntroLoopMaxVolume,
      2,
      musicManager.gambleID[0]
    );
  }
};

musicManager.hookStart = function () {
  soundManager.play("hookMusic");
  soundManager.play("hookSound");

  if (musicManager.inMaxPlay) {
    musicManager.fadeMaxPlayLevels(musicManager.MAXPLAY_ALLOFF, 0.5, 0.5);
  } else {
    musicManager.fadeLevels(musicManager.ALLOFFLEVEL, 0.5, 0.5);
  }
};

musicManager.hookEnd = function () {
  if (musicManager.inMaxPlay) {
    musicManager.fadeMaxPlayLevels(
      musicManager.MAXPLAY_BASE,
      musicManager.fadeBaseTimeIn,
      musicManager.fadeBaseTimeOut
    );
  } else {
    musicManager.fadeLevels(
      musicManager.IDLELEVEL,
      musicManager.fadeBaseTimeIn,
      musicManager.fadeBaseTimeOut
    );
  }
};

musicManager.maxPlayEnter = function () {
  timerManager.stop(musicManager.stepDownTimer);
  musicManager.fadeMaxPlayLevels(musicManager.MAXPLAY_BASE, 2, 2);
  musicManager.fadeLevels(musicManager.ALLOFFLEVEL, 1, 1);
  musicManager.inMaxPlay = true;
};

musicManager.maxPlayExit = function () {
  timerManager.stop(musicManager.stepDownTimer);
  musicManager.fadeMaxPlayLevels(musicManager.ALLOFFLEVEL, 1, 1);
  musicManager.inMaxPlay = false;

  if (!musicManager.inFreespins) {
    musicManager.fadeLevels(musicManager.IDLELEVEL, 2, 2);
  }
};

musicManager.onFreeSpinsWon = function () {
  timerManager.stop(musicManager.stepDownTimer);
  musicManager.fadeLevels(
    musicManager.ALLOFFLEVEL,
    musicManager.fadeBaseTimeIn,
    0.3
  );
  musicManager.fadeMaxPlayLevels(
    musicManager.MAXPLAY_ALLOFF,
    musicManager.fadeBaseTimeIn,
    0.3
  );
  musicManager.playing = false;

  soundManager.play("scatterWin");
};

musicManager.onFreespinsIntro = function () {
  soundManager.play("bubblesIntro");
  soundManager.play("freeSpinsIntro");

  musicManager.fsIntroTimer = timerManager.addTimeout(2500, () => {
    soundManager.fade(
      musicManager.freeSpinsIntroLoopMaxVolume,
      0.5,
      musicManager.freeSpinsIntroLoop
    );
  });
};

musicManager.onFreespinsStart = function (level) {
  if (musicManager.fsIntroTimer != null) {
    timerManager.stop(musicManager.fsIntroTimer);
    musicManager.fsIntroTimer = null;
  }

  soundManager.fade(0, 0.7, musicManager.freeSpinsIntroLoop, () => {
    musicManager.setFreeSpinsLevel(level);
  });
  timerManager.stop(musicManager.stepDownTimer);

  musicManager.inFreespins = true;
  musicManager.playing = false;
};

musicManager.setFreeSpinsLevel = function (level) {
  const before = musicManager.freeSpinsLevel;

  switch (level) {
    case 0:
      musicManager.freeSpinsLevel = musicManager.FREESPINS_BASE;
      break;

    case 1:
      musicManager.freeSpinsLevel = musicManager.FREESPINS_LEVEL1;
      break;

    case 2:
      musicManager.freeSpinsLevel = musicManager.FREESPINS_LEVEL1;
      break;

    case 3:
      musicManager.freeSpinsLevel = musicManager.FREESPINS_LEVEL2;
      break;
  }

  if (before != musicManager.freeSpinsLevel) {
    musicManager.fadeFSLevels(
      musicManager.freeSpinsLevel,
      musicManager.fadeBaseTimeIn,
      musicManager.fadeBaseTimeOut
    );
  }
};

musicManager.onFreespinsOutro = function () {
  musicManager.inFreespins = false;
  musicManager.wasInFreeSpins = true;
  musicManager.fadeFSLevels(
    musicManager.FREESPINS_ALLOFF,
    musicManager.fadeBaseTimeIn,
    0.5
  );
  musicManager.freeSpinsLevel = musicManager.FREESPINS_ALLOFF;

  soundManager.play("bubblesIntro");
  soundManager.play("freeSpinsOutro");

  timerManager.addTimeout(1000, () => {
    if (musicManager.inMaxPlay) {
      musicManager.fadeMaxPlayLevels(
        musicManager.MAXPLAY_LEVEL1,
        4,
        musicManager.fadeBaseTimeOut
      );
    } else {
      musicManager.fadeLevels(
        musicManager.SPINLEVEL,
        4,
        musicManager.fadeBaseTimeOut
      );
    }

    musicManager.stepDownTimer = timerManager.addTimeout(
      musicManager.stepDownDuration,
      () => {
        musicManager.stepDown();
      }
    );
  });
};

musicManager.onFreespinsEnd = function () {
  musicManager.inFreespins = false;
  musicManager.wasInFreeSpins = true;
  musicManager.fadeFSLevels(
    musicManager.FREESPINS_ALLOFF,
    musicManager.fadeBaseTimeIn,
    0.5
  );

  musicManager.freeSpinsLevel = musicManager.FREESPINS_ALLOFF;

  if (musicManager.inMaxPlay) {
    musicManager.fadeMaxPlayLevels(
      musicManager.MAXPLAY_LEVEL1,
      4,
      musicManager.fadeBaseTimeOut
    );
  } else {
    musicManager.fadeLevels(
      musicManager.SPINLEVEL,
      4,
      musicManager.fadeBaseTimeOut
    );
  }

  musicManager.stepDownTimer = timerManager.addTimeout(
    musicManager.stepDownDuration,
    () => {
      musicManager.stepDown();
    }
  );
};

musicManager.onPlayBubbleIntro = function () {
  soundManager.play("bubblesIntro");
};

musicManager.returnToIdle = function () {
  if (musicManager.inMaxPlay) {
    musicManager.fadeMaxPlayLevels(
      musicManager.MAXPLAY_BASE,
      musicManager.fadeBaseTimeIn,
      musicManager.fadeBaseTimeOut
    );
  } else {
    musicManager.fadeLevels(
      musicManager.IDLELEVEL,
      musicManager.fadeBaseTimeIn,
      musicManager.fadeBaseTimeOut
    );
  }
};

musicManager.update = function () {};

musicManager.onRestorePreviouslyPlayingAudio = function (data) {
  if (data.reason === "back from replay" && !Reflex.replayGame) {
    musicManager.basePlaying = [false, false, false, false];
    musicManager.baseID = [];
    musicManager.fsPlaying = [false, false, false];
    musicManager.freeSpinsID = [];
    musicManager.maxPlayPlaying = [false, false, false, false];
    musicManager.maxPlayID = [];
    musicManager.gambleID = [];
    musicManager.onGameLoaded();
    if (musicManager.inMaxPlay === true) {
      musicManager.maxPlayEnter();
    }
  }
};

Reflex.addToUpdate(musicManager.update);

Reflex.registerInitialiseManager(musicManager.initialise);

messageBus.subscribe(
  "sounds:restorePreviouslyPlayingAudio",
  musicManager.onRestorePreviouslyPlayingAudio
);
